var React = require('react');

function CloseX (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/close-x"),React.createElement("g",{"id":"icon/close-x","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"Path","fill":"currentColor","fillRule":"nonzero","points":"32 3.06690778 28.9330922 0 16 12.9330922 3.06690778 0 1.0658141e-14 3.06690778 12.9330922 16 1.19430284e-14 28.9330922 3.06690778 32 16 19.0669078 28.9330922 32 32 28.9330922 19.0669078 16"}))]);
}

CloseX.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = CloseX;

CloseX.default = CloseX;
